import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mascara'
})
export class MascaraPipe implements PipeTransform {
  private readonly CARACTERES_ESPECIAIS = ['/', '(', ')', '.', ':', '-', ' ', '+'];

  private readonly PADROES_DISPONIVEIS: { [index: string]: RegExp | undefined } = {
    0: /\d/,
    9: /\d/,
    A: /[a-zA-Z0-9]/,
    S: /[a-zA-Z]/
  };

  transform(value: string, mascaraExpressao: string): unknown {
    return this.aplicarMascara(value, mascaraExpressao);
  }

  private aplicarMascara(inputValor: string, mascaraExpressao: string | undefined): string {
    if (!inputValor) {
      return '';
    }

    let cursor = 0;
    let resultado = '';
    const inputArray: string[] = inputValor.toString().split('');

    if (!mascaraExpressao) {
      mascaraExpressao = '';
    }

    for (let i = 0, inputSimbolos: string = inputArray[0]; i < inputArray.length; i++, inputSimbolos = inputArray[i]) {
      if (resultado.length === mascaraExpressao.length) {
        break;
      }

      if (this.validarSimbolosMascara(inputSimbolos, mascaraExpressao[cursor])) {
        resultado += inputSimbolos;
        cursor++;
      } else if (this.CARACTERES_ESPECIAIS.indexOf(mascaraExpressao[cursor]) !== -1) {
        resultado += mascaraExpressao[cursor];
        cursor++;
        i--;
      } else if (mascaraExpressao[cursor] === '9') {
        cursor++;
        i--;
      }
    }

    if (resultado.length + 1 === mascaraExpressao.length
      && this.CARACTERES_ESPECIAIS.indexOf(mascaraExpressao[mascaraExpressao.length - 1]) !== -1) {
      resultado += mascaraExpressao[mascaraExpressao.length - 1];
    }
    return resultado;
  }


  private validarSimbolosMascara(inputSimbolos: string, simbolosMascaras: string): boolean {
    const regex = this.PADROES_DISPONIVEIS[simbolosMascaras];

    if (regex) {
      return regex.test(inputSimbolos);
    }

    return false;
  }

}
